import type { InvoiceLink } from "@jti/fe-common";

import { CasBaseApi } from "../../CasBaseApi";
import type { CasInvoiceApiContract } from "../CasInvoiceApi.types";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class CasInvoiceApiLegacy extends CasBaseApi implements CasInvoiceApiContract {
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken: string,
    protected userUuid: string
  ) {
    super(baseUrl, tenantToken, ciamToken, userUuid);
  }

  async getInvoicePdf(id: string): Promise<InvoiceLink> {
    return this.request<InvoiceLink>(
      `/orders/${this.userUuid}/${id}/invoice`,
      {
        method: "GET",
      },
      true
    );
  }
}
